// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right[data-v-662ed1b2]{text-align:right}.detail[data-v-662ed1b2]{color:#666;font-size:.8em}.per[data-v-662ed1b2]{font-style:italic;text-align:center;width:100%;display:block}.spacer[data-v-662ed1b2]{height:24px}.spacer *[data-v-662ed1b2]{position:relative;top:50%}.swatch[data-v-662ed1b2]{width:12px;height:12px;content:\" \";display:block;background:#00f}.center[data-v-662ed1b2],.centered-input[data-v-662ed1b2] input{text-align:center}", ""]);
// Exports
module.exports = exports;
